import axios from "axios/index";
import {SERVICE_URL} from "./constants";

export const validateStatus = status => response => {
  if (response.status !== status) {
    throw new Error('Service returned a non OK status code');
  }
  return response;
};

export const getHeaders = (accessToken) => {
  return {
    Authorization: `Bearer ${accessToken}`,
  };
};

export const convertObjectToSearchParams = (params) => {
  return Object.keys(params).map((key) => {
    return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
  }).join('&');
};

export function getAll(typeName) {
  return axios.get(`${SERVICE_URL}/${typeName}`)
    .then(validateStatus(200))
    .then(response => response.data)
    .then(responseData => {
      console.info(`[api.helpers.getAll(${typeName})] response`, responseData);
      return responseData;
    });
}

export function get(typeName, id) {
  return axios.get(`${SERVICE_URL}/${typeName}/${id}`)
    .then(validateStatus(200))
    .then(response => response.data)
    .then(responseData => {
      console.info(`[api.user.get(${typeName}/${id})] response`, responseData);
      return responseData;
    });
}

export function update(typeName, payload, objectId) {
  
  const headers = {
    'Content-Type': 'application/json',
  };

  return axios.patch(`${SERVICE_URL}/${typeName}/${objectId}`,
    {payload},
    headers)
    .then(validateStatus(200))
    .then(response => response.data)
    .then(responseData => {
      console.info(`[api.helpers.update(${typeName}, ${objectId})] response`, responseData);
      return responseData;
    });
}

export function insert(typeName, payload) {
  return axios.post(`${SERVICE_URL}/${typeName}`, payload)
    .then(validateStatus(200))
    .then(response => response.data)
    .then(responseData => {
      console.info(`[api.helpers.insert(${typeName}] response`, responseData);
      return responseData;
    });
}



// WEBPACK FOOTER //
// ./src/api/helpers.js